import LogoLucci from '../assets/Logo.svg';
import './FallbackSpinnerLoader.scss';

const FallbackSpinnerLoader = () => {
  return (
    <div className="spinner__container">
      <img src={LogoLucci} alt="spinner" />
    </div>
  );
};

export default FallbackSpinnerLoader;
